import { useEffect, useState } from 'react';

/**
 * Si el telefono tiene conexion.
 *
 * `navigator.onLine` dice que hay un enlace de red, no que el servidor
 * responda: con una barra de cobertura en un sotano puede seguir diciendo que
 * si. Sirve para lo unico que se le pide aqui —avisar de que no hay red antes
 * de que el chofer tome una fotografia que no va a poder subir— y por eso el
 * aviso que lo usa no promete mas de lo que sabe.
 */
export function useOnline(): boolean {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const update = (): void => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', update);
    window.addEventListener('offline', update);

    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  return isOnline;
}
